export default __webpack_public_path__ + "static/media/PR.d4332ce5.webp";